module.exports = __webpack_public_path__ + "static/media/1POLICY4.a676a9eb.jpg";